import {
  PRESUPUESTADOR_RESERVA_MODAL_ACTUALIZAR_STEPS,
  PRESUPUESTADOR_RESERVA_MODAL_STEP_ACTIVO,
  PRESUPUESTADOR_RESERVA_MODAL_CERRAR,
} from './constants'
import { MODAL_RESERVA_STEPS } from '../ModalDeReserva.constants'

export const validarCliente = cliente => {
  if (cliente.client_type === 'HUMANA') {
    return (
      !!cliente.apellido &&
      !!cliente.nombre &&
      !!cliente.email &&
      !!cliente.telefono &&
      !!cliente.cuil_cuit &&
      !!cliente.zip_code &&
      !!cliente.provincia &&
      !!cliente.direccion &&
      !!cliente.localidad &&
      !!cliente.pais && 
      !!cliente.condicion_iva
    )
  } else {
    return (
      !!cliente.email &&
      !!cliente.telefono &&
      !!cliente.cuil_cuit &&
      !!cliente.zip_code &&
      !!cliente.provincia &&
      !!cliente.direccion &&
      !!cliente.localidad &&
      !!cliente.razon_social &&
      !!cliente.pais &&
      !!cliente.condicion_iva
    )
  }
}

export function nextModalStep() {
  return (dispatch, getState) => {
    const { presupuestador = {} } = getState()
    const { modalDeReserva } = presupuestador

    const nextStepIndex = modalDeReserva.currentStep.order + 1

    dispatch({
      type: PRESUPUESTADOR_RESERVA_MODAL_STEP_ACTIVO,
      data: modalDeReserva.steps[nextStepIndex]
    })
  }
}

export function previousModalStep() {
  return (dispatch, getState) => {
    const { presupuestador = {} } = getState()
    const { modalDeReserva } = presupuestador

    const previousStepindex = modalDeReserva.currentStep.order - 1

    dispatch({
      type: PRESUPUESTADOR_RESERVA_MODAL_STEP_ACTIVO,
      data: modalDeReserva.steps[previousStepindex]
    })
  }
}

export function finishSteps() {
  return (dispatch) => {
    const completedStep = {
      type: MODAL_RESERVA_STEPS.COMPLETED
    }

    dispatch({
      type: PRESUPUESTADOR_RESERVA_MODAL_STEP_ACTIVO,
      data: completedStep
    })
  }
}

export function generateSteps(idCliente) {
  return (dispatch, getState) => {
    const { presupuestador = {}, common: { user: { license: { allowAnyBranchOnBudgetCreation } } } } = getState()
    const steps = []
    let order = 0
    let currentIndex = 0

    const usadosSinPeritaje = presupuestador.entregaUsados?.some(
      usado => !usado.peritado || Number(usado.peritado) < 1
    )
    const existenUsados = presupuestador.entregaUsados?.length > 0

    const clienteAsignado = !!idCliente || !!presupuestador?.client_id
    const clienteCompleto =
      clienteAsignado && validarCliente(presupuestador.cliente)
    const coloresDisponibles = !!presupuestador?.nuevo?.colors?.length > 0
    const nuevo = presupuestador?.nuevo?.nuevo
    const selectedStock = presupuestador?.selectedStock

    const isSameOwner = presupuestador?.nuevo?.car_lot_id === presupuestador?.nuevo?.owner_id
    const isSelectedBranchOffice = presupuestador.integration_branch_office_id
    const showAnyBranchModal = nuevo && allowAnyBranchOnBudgetCreation
    const hasStepBranchOffice = !nuevo && !isSameOwner || showAnyBranchModal
    const hasStepColors = nuevo && coloresDisponibles && !selectedStock
    const hasNotReservedColors = (presupuestador?.reservedColors?.length === 0 || presupuestador?.reservedColors === null)

    const clienteStep = {
      label: 'Datos del cliente',
      type: MODAL_RESERVA_STEPS.CLIENTE,
      order,
      canGoBack: false
    }
    steps.push(clienteStep)
    order += 1
    
    if (existenUsados) {
      const peritajeStep = {
        label: 'Solicitud de peritaje',
        type: MODAL_RESERVA_STEPS.PERITAJE,
        order,
        canGoBack: order > 0
      }
      steps.push(peritajeStep)
      order += 1
    }

    if (hasStepColors) {
      const coloresStep = {
        label: 'Colores de vehículo',
        type: MODAL_RESERVA_STEPS.COLORES,
        isOptional: true,
        order,
        canGoBack: order > 0
      }
      steps.push(coloresStep)
      order += 1
    }
    
    if (hasStepBranchOffice) {
      const sucursalesStep = {
        label: showAnyBranchModal ? 'Dueño de operación' : 'Sucursal dueño',
        type: MODAL_RESERVA_STEPS.SUCURSALES,
        order,
        canGoBack: order > 0
      }
      steps.push(sucursalesStep)
      order += 1
    }
    
    const pagosStep = {
      label: 'Reserva',
      type: MODAL_RESERVA_STEPS.PAGOS,
      order,
      canGoBack: order > 0
    }
    steps.push(pagosStep)

    // Lógica para calcular cual es el paso seleccionado
    if (!clienteCompleto || !clienteAsignado) {
      currentIndex = steps.find(cur => cur.type === MODAL_RESERVA_STEPS.CLIENTE).order
    } else if (usadosSinPeritaje) {
      currentIndex = steps.find(cur => cur.type === MODAL_RESERVA_STEPS.PERITAJE).order
    } else if (hasNotReservedColors && hasStepColors) {
      currentIndex = steps.find(cur => cur.type === MODAL_RESERVA_STEPS.COLORES).order
    } else if (!isSelectedBranchOffice && hasStepBranchOffice) {
      currentIndex = steps.find(cur => cur.type === MODAL_RESERVA_STEPS.SUCURSALES).order
    } else {
      currentIndex = steps.length - 1
    }

    if (steps.length > 0) {
      const lastStepIndex = steps.length - 1
      steps[lastStepIndex].isLastStep = true

      dispatch({
        type: PRESUPUESTADOR_RESERVA_MODAL_ACTUALIZAR_STEPS,
        data: steps
      })

      dispatch({
        type: PRESUPUESTADOR_RESERVA_MODAL_STEP_ACTIVO,
        data: steps[currentIndex]
      })
    } else {
      this.finishSteps()
    }
  }
}

export function closeModalReserva() {
  return (dispatch) => {
    dispatch({
      type: PRESUPUESTADOR_RESERVA_MODAL_CERRAR
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_RESERVA_MODAL_ACTUALIZAR_STEPS:
      return {
        ...state,
        modalDeReserva: {
          ...state.modalDeReserva,
          steps: action.data,
          modalActive: true,
        }
      }
    case PRESUPUESTADOR_RESERVA_MODAL_STEP_ACTIVO:
      return {
        ...state,
        modalDeReserva: {
          ...state.modalDeReserva,
          currentStep: action.data,
          modalActive: true,
        }
      }
    case PRESUPUESTADOR_RESERVA_MODAL_CERRAR:
      return {
        ...state,
        modalActive: false,
      }
    default:
      return state
  }
}
